import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { DownloadBillingAndSoaForm } from '@/components/forms/DownloadBillingAndSoaForm'

export default function DownloadBillingAndSoaPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams<{ shippingLineId: string; billingStatementId: string; soaId: string }>()
  const paramsShippingLineId = params.shippingLineId
  const billingStatementId = params.billingStatementId ? parseInt(params.billingStatementId, 10) : undefined
  const soaId = params.soaId ? parseInt(params.soaId, 10) : undefined

  // Get data from navigation state or route params
  const navigationState = location.state as
    | {
        shippingLineName?: string
        shippingLineId?: string
        billingStatementId?: number
        soaId?: number
    }
    | null

  const finalShippingLineId =
    navigationState?.shippingLineId || paramsShippingLineId
  const finalBillingStatementId = navigationState?.billingStatementId || billingStatementId
  const finalSoaId = navigationState?.soaId || soaId
  const shippingLineName = navigationState?.shippingLineName || ''

  const handleSuccess = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  const handleCancel = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Download Billing Statement and SOA
            </Heading>
          </CardHeader>
          <CardBody>
            <DownloadBillingAndSoaForm
              shippingLineId={finalShippingLineId || ''}
              shippingLineName={shippingLineName}
              billingStatementId={finalBillingStatementId}
              soaId={finalSoaId}
              onSuccess={handleSuccess}
              onCancel={handleCancel}
            />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}

